{
  "PDF preview": "Vista previa de PDF",
  "Zoom out": "Alejar",
  "Zoom in": "Acercar",
  "Fit width": "Ajustar al ancho",
  "Choose valid collection columns without duplicates.": "Elige columnas válidas para la lista sin duplicados.",
  "Settings": "Configuración",
  "Main menu": "Menú principal",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", no",
  ". Changing construction class requires a different identity.": ". Cambiar el tipo constructivo requiere otra identidad.",
  ". It is shown only once.": ". Se muestra una sola vez.",
  ". Where-used follows the actual structure—not the numbering path.": ". Los usos siguen la estructura real, no la ruta de numeración.",
  "? The history remains.": "? El historial se conserva.",
  "? The original part remains in the registry.": "? La pieza original permanece en el registro.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "Un PIN requiere proyecto, versión de producto y al menos un nodo de identidad; profundidad máxima: 32.",
  "A change is awaiting confirmation": "Cambio pendiente de confirmación",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "Un cambio constructivo controlado requiere otra pieza, no renombrar esta.",
  "A new link will replace the previous invitation link for": "El nuevo enlace sustituirá la invitación anterior de",
  "A part cannot replace itself.": "Una pieza no puede sustituirse a sí misma.",
  "A piece part cannot have a configuration.": "Una pieza individual no puede tener configuración.",
  "A piece part cannot have controlled children.": "Una pieza individual no puede contener componentes controlados.",
  "A piece part cannot retain controlled children.": "Una pieza individual no puede conservar componentes controlados.",
  "A qualified reference must select a released revision.": "Una referencia cualificada debe seleccionar una revisión publicada.",
  "A verified Google email is required.": "Se requiere un correo de Google verificado.",
  "ALPHA": "ALPHA",
  "About {value0}": "Acerca de {value0}",
  "Accept company invitation": "Aceptar invitación a la empresa",
  "Account": "Cuenta",
  "Account and company settings": "Ajustes de cuenta y empresa",
  "Active": "Activa",
  "Active assembly": "Conjunto actual",
  "Add alias": "Añadir número externo",
  "Add code": "Añadir código",
  "Add directional replacement": "Añadir sustitución direccional",
  "Add part": "Añadir pieza",
  "Add replacement": "Añadir sustitución",
  "Add to {value0}": "Añadir a {value0}",
  "Adding…": "Añadiendo…",
  "Alias notes": "Notas del número externo",
  "Alias organization": "Organización del número externo",
  "Alias type": "Tipo de número externo",
  "All alias types": "Todos los tipos de números externos",
  "All companies": "Todas las empresas",
  "All selected child revisions must be released.": "Todas las revisiones de componentes seleccionadas deben estar publicadas.",
  "All states": "Todos los estados",
  "All types": "Todos los tipos",
  "Aluminium": "Aluminio",
  "An assembly needs at least one controlled child before release.": "Un conjunto necesita al menos un componente controlado antes de publicarse.",
  "An example drawing change tightens a tolerance.": "El cambio de plano del ejemplo reduce una tolerancia.",
  "An external alias cannot impersonate another canonical part number.": "Un número externo no puede suplantar el número canónico de otra pieza.",
  "An identifier or historical alias already occupies the requested number.": "El número ya está ocupado por una identidad o un alias histórico.",
  "An independently orderable configured product needs its own assembly P/N.": "Un producto configurado que se pide por separado necesita su propio número de conjunto.",
  "An invitation is already pending. Replace its link instead.": "Ya hay una invitación pendiente. Sustituya su enlace.",
  "An occurrence cannot be moved to another owner by editing it.": "No se puede cambiar la estructura propietaria de un uso editándolo.",
  "Another change was being saved. Retry this same request.": "Se estaba guardando otro cambio. Repita la misma solicitud.",
  "Another owner must accept membership before removing the last owner.": "Otro propietario debe aceptar la invitación antes de retirar al último propietario.",
  "Another project": "Otro proyecto",
  "Apply filters": "Aplicar filtros",
  "Arm": "Brazo",
  "Arm assembly": "Conjunto del brazo",
  "As authored": "Según lo definido",
  "Ask a company owner to register a new code.": "Pida al propietario de la empresa que registre un código nuevo.",
  "Assembly": "Conjunto",
  "Assembly configurations": "Configuraciones del conjunto",
  "Assignment correction": "Corrección de asignación",
  "Back to blueprint": "Volver al plano",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "Antes de tener dependencias controladas, corrija la asignación con registro de auditoría. No se conserva redirección del número anterior.",
  "Best match": "Mejor coincidencia",
  "Bonded": "Pegado",
  "Bonded assembly": "Conjunto pegado",
  "Bonded grip": "Agarre pegado",
  "Both leaders point to the same P/N.": "Ambas líneas apuntan al mismo número de pieza.",
  "CF": "CF",
  "Cancel": "Cancelar",
  "Cancel {value0} edit": "Cancelar edición de {value0}",
  "Carbon fibre": "Fibra de carbono",
  "Change {value0}'s role": "Cambiar el rol de {value0}",
  "Check result": "Comprobar resultado",
  "Choose Active, Obsolete or Retired.": "Elija Activo, Obsoleto o Retirado.",
  "Choose Owner, Editor or Viewer.": "Elija Propietario, Editor o Lector.",
  "Choose P, A, W, G or R.": "Elija P, A, W, G o R.",
  "Choose a company": "Elegir empresa",
  "Choose a measurement unit preference.": "Elija un sistema de unidades.",
  "Choose a part and exact revision from this company.": "Elija una pieza y su revisión exacta de esta empresa.",
  "Choose a product version from the default project.": "Elija una versión del producto del proyecto predeterminado.",
  "Choose a standard position or register its code in this company.": "Elija una posición estándar o registre su código en esta empresa.",
  "Choose a supplier, manufacturer or customer alias.": "Elija un número de proveedor, fabricante o cliente.",
  "Choose a supported interface language.": "Elija un idioma de interfaz compatible.",
  "Choose a supported regional format.": "Elija un formato regional compatible.",
  "Choose a table density.": "Elija una densidad de tabla.",
  "Choose a valid alias type.": "Elija un tipo de número externo válido.",
  "Choose a valid part state.": "Elija un estado de pieza válido.",
  "Choose a valid part type.": "Elija un tipo de pieza válido.",
  "Choose a valid results page and page size.": "Elija una página y un tamaño de página válidos.",
  "Choose a valid search order.": "Elija un orden de búsqueda válido.",
  "Choose a valid time zone.": "Elija una zona horaria válida.",
  "Choose an assembly parent in the selected product version.": "Elija un conjunto padre de esta versión de producto.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Elija un padre de esta versión de producto fuera de los descendientes de esta identidad.",
  "Choose an editable assembly and an exact part revision.": "Elija un conjunto editable y una revisión exacta de pieza.",
  "Choose each time": "Elegir cada vez",
  "Choose exactly one structure owner.": "Elija exactamente un propietario de estructura.",
  "Choose its revision and quantity to add it to this assembly.": "Elija la revisión y la cantidad que se añadirán a este conjunto.",
  "Choose one structure owner.": "Elija un propietario de estructura.",
  "Choose the default company first.": "Elija primero la empresa predeterminada.",
  "Choose the part that can replace this one.": "Elija la pieza que puede sustituir a esta.",
  "Class": "Clase",
  "Clear filters": "Borrar filtros",
  "Close": "Cerrar",
  "Close reuse parts": "Cerrar reutilización de piezas",
  "Close {value0}": "Cerrar {value0}",
  "Code": "Código",
  "Comfortable": "Cómoda",
  "Compact": "Compacta",
  "Companies": "Empresas",
  "Company": "Empresa",
  "Company code": "Código de empresa",
  "Company name": "Nombre de empresa",
  "Company not found.": "No se encontró la empresa.",
  "Company parts": "Piezas de la empresa",
  "Company settings": "Ajustes de la empresa",
  "Company-wide role": "Rol en la empresa",
  "Configuration": "Configuración",
  "Configuration name": "Nombre de configuración",
  "Configurations": "Configuraciones",
  "Configurations apply to assemblies, not piece parts.": "Las configuraciones se aplican a conjuntos, no a piezas individuales.",
  "Construction classes": "Tipos constructivos",
  "Copy a revision of this part.": "Copiar una revisión de esta pieza.",
  "Correct engineering identity": "Corregir identidad técnica",
  "Corrected text": "Texto corregido",
  "Correction & replacement": "Corrección y sustitución",
  "Correction reason": "Motivo de corrección",
  "Cover": "Cubierta",
  "Cover numbered beneath it": "Cubierta numerada bajo este conjunto",
  "Cover revisions": "Revisiones de la cubierta",
  "Cover · 1 each · forearm": "Cubierta · 1 unidad · antebrazo",
  "Create company": "Crear empresa",
  "Create configuration": "Crear configuración",
  "Create invitation": "Crear invitación",
  "Create project": "Crear proyecto",
  "Create variant": "Crear variante",
  "Create version": "Crear versión",
  "Current structure": "Estructura actual",
  "Default quantity unit": "Unidad de cantidad predeterminada",
  "Default workspace": "Espacio de trabajo predeterminado",
  "Description": "Descripción",
  "Details": "Detalles",
  "Different identity": "Otra identidad",
  "Directional replacements": "Sustituciones direccionales",
  "Draft": "Borrador",
  "Drawing unavailable. Part-number examples remain interactive.": "Plano no disponible. Los ejemplos de números siguen siendo interactivos.",
  "ER": "ER",
  "Edit company": "Editar empresa",
  "Edit configuration": "Editar configuración",
  "Edit details": "Editar detalles",
  "Edit part details": "Editar detalles de pieza",
  "Edit part use": "Editar uso de pieza",
  "Edit product version": "Editar versión de producto",
  "Edit project": "Editar proyecto",
  "Editor": "Editor",
  "Engineering": "Ingeniería",
  "Engineering Registry": "Registro de ingeniería",
  "Enter a canonical PIN.": "Introduzca un PIN canónico.",
  "Enter a position code.": "Introduzca un código de posición.",
  "Enter a positive quantity and a unit.": "Introduzca una cantidad positiva y una unidad.",
  "Enter a valid email address.": "Introduce una dirección válida.",
  "Enter a variant code.": "Introduzca un código de variante.",
  "Exact child revision": "Revisión exacta del componente",
  "Exact children in this baseline": "Componentes exactos de esta línea base",
  "Existing codes…": "Códigos existentes…",
  "Existing hand, used in V": "Mano existente, utilizada en V",
  "Existing part": "Pieza existente",
  "Explain": "Explicar",
  "External aliases": "Números externos",
  "External part number": "Número de pieza externo",
  "Filters": "Filtros",
  "Find an existing part": "Buscar pieza existente",
  "Find parts": "Buscar piezas",
  "Find {value0}": "Buscar {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "Para una pieza independiente, deje vacía la pieza relacionada para asignar un número nuevo.",
  "Forearm cover": "Cubierta del antebrazo",
  "Front view · left/right is the robot’s own left/right": "Vista frontal · izquierda/derecha del robot",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Vista frontal: la mano derecha del robot está a la izquierda del dibujo; la izquierda, a la derecha.",
  "Google account email": "Correo de la cuenta de Google",
  "Google could not verify this sign-in. Try again.": "Google no pudo verificar el acceso. Inténtelo de nuevo.",
  "Google sign-in could not load. Check your connection and try again.": "No se pudo cargar el acceso de Google. Revise la conexión y reintente.",
  "Google sign-in is not configured.": "El acceso de Google no está configurado.",
  "Hand identities": "Identidades de las manos",
  "Head casing": "Carcasa de la cabeza",
  "Hide": "Ocultar",
  "Historical rename": "Cambio de nombre histórico",
  "History": "Historial",
  "Hole Ø6 mm · tolerance ±": "Orificio Ø6 mm · tolerancia ±",
  "Identity family": "Familia de identidades",
  "Identity history examples": "Ejemplos del historial de identidad",
  "Illustrative example · not your registry": "Ejemplo ilustrativo · no es su registro",
  "Imperial": "Imperiales",
  "Interactive robot part numbers": "Números de piezas interactivos del robot",
  "Invitation link": "Enlace de invitación",
  "Invitation not found.": "No se encontró la invitación.",
  "Invite person": "Invitar persona",
  "Issue part number": "Asignar número de pieza",
  "Issue variant": "Asignar variante",
  "Issuing the cover beneath it appends": "El número de una cubierta bajo este conjunto añade",
  "It does not tell you where it is used now.": "Esto no indica dónde se utiliza ahora.",
  "Keep the part number and name columns; each column may appear only once.": "Conserve número y nombre; cada columna puede aparecer solo una vez.",
  "Knee pin ×2": "Pasador de rodilla ×2",
  "Language": "Idioma",
  "Left / right": "Izquierda / derecha",
  "Left hand": "Mano izquierda",
  "Left hand · 1 each · wrist": "Mano izquierda · 1 unidad · muñeca",
  "Loading…": "Cargando…",
  "Main navigation": "Navegación principal",
  "Material": "Material",
  "Meaning": "Significado",
  "Measurement units": "Unidades de medida",
  "Members": "Miembros",
  "Metric": "Métricas",
  "Move {column} down": "Bajar {column}",
  "Move {column} up": "Subir {column}",
  "Name": "Nombre",
  "Navigation": "Navegación",
  "Neither family membership nor a variant code promises interchangeability.": "Ni la familia ni el código de variante garantizan intercambiabilidad.",
  "New assembly": "Nuevo ensamblaje",
  "New camera in V2": "Nueva cámara en V2",
  "New camera, first numbered in V2": "Nueva cámara, numerada por primera vez en V2",
  "New codes are registered by a company owner.": "Los códigos nuevos los registra un propietario de la empresa.",
  "New company": "Nueva empresa",
  "New configuration": "Nueva configuración",
  "New part": "Nueva pieza",
  "New product version": "Nueva versión de producto",
  "New project": "Nuevo proyecto",
  "New revision": "Nueva revisión",
  "New version": "Nueva versión",
  "No choices available.": "No hay opciones disponibles.",
  "No parts yet.": "Aún no hay piezas.",
  "No selected occurrences.": "No hay usos seleccionados.",
  "None": "Ninguna",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Aún sin confirmar. Reintente el cambio conservado para resolverlo de forma segura.",
  "Not found.": "No se encontró.",
  "Notes": "Notas",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Numerar bajo un conjunto no añade la cubierta a su estructura. Se añade por separado; al reutilizarla conserva este número.",
  "Numbering concept": "Concepto de numeración",
  "Numbering path": "Ruta de numeración",
  "Obsolete": "Obsoleto",
  "Old text": "Texto anterior",
  "Only !REV changes.": "Solo cambia !REV.",
  "Only company owners can manage membership.": "Solo los propietarios de la empresa pueden gestionar miembros.",
  "Only the configured administrator can create companies.": "Solo el administrador configurado puede crear empresas.",
  "Open PIN": "Abrir PIN",
  "Open navigation": "Abrir navegación",
  "Open project explorer": "Abrir explorador de proyectos",
  "Organization": "Organización",
  "Original identity": "Identidad original",
  "Overview": "Resumen",
  "Owner": "Propietario",
  "P/N prefix": "Prefijo del número",
  "P/N preview": "Vista previa del número",
  "Page not found": "Página no encontrada",
  "Part": "Pieza",
  "Part name": "Nombre de pieza",
  "Part number": "Número de pieza",
  "Part number preview": "Vista previa del número de pieza",
  "Part number ↑": "Número de pieza ↑",
  "Part number ↓": "Número de pieza ↓",
  "Part number, name, material or alias": "Número, nombre, material o número externo",
  "Part numbering guide": "Guía de numeración de piezas",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Los prefijos cambian juntos; los identificadores históricos controlados conservan redirecciones.",
  "Part record": "Ficha de pieza",
  "Part section": "Sección de pieza",
  "Part type": "Tipo de pieza",
  "Parts": "Piezas",
  "Parts first numbered in this product version.": "Piezas numeradas por primera vez en esta versión de producto.",
  "Per page": "Por página",
  "Personal preferences": "Preferencias personales",
  "Piece": "Pieza",
  "Piece part": "Pieza individual",
  "Piece parts cannot have controlled children.": "Las piezas individuales no pueden contener componentes controlados.",
  "Piece parts do not have assembly configurations.": "Las piezas individuales no tienen configuraciones de conjunto.",
  "Position": "Posición",
  "Position code": "Código de posición",
  "Position codes contain 1–12 uppercase letters.": "Los códigos de posición contienen de 1 a 12 letras latinas mayúsculas.",
  "Product shown": "Producto mostrado",
  "Product version": "Versión del producto",
  "Product versions": "Versiones del producto",
  "Project": "Proyecto",
  "Project / product version": "Proyecto / versión de producto",
  "Project code": "Código del proyecto",
  "Project explorer": "Explorador de proyectos",
  "Project name": "Nombre del proyecto",
  "Project settings": "Ajustes del proyecto",
  "Project workspace": "Espacio de trabajo del proyecto",
  "Projects": "Proyectos",
  "Quantity": "Cantidad",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Cantidad y posición pertenecen a cada uso, no a la identidad de la pieza. Ambas rodillas seleccionan la revisión 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "La cantidad debe ser positiva, como máximo mil millones, con hasta seis decimales.",
  "ROBOT project": "Proyecto ROBOT",
  "Reason for changing the code": "Motivo del cambio de código",
  "Reason for correcting the code": "Motivo de corrección del código",
  "Reason for correcting version number": "Motivo de corrección del número de versión",
  "Regional format": "Formato regional",
  "Register code": "Registrar código",
  "Register variant code": "Registrar código de variante",
  "Registered meanings cannot be reassigned after use.": "Los significados registrados no se pueden reasignar después de usarse.",
  "Registered {value0} codes": "Códigos {value0} registrados",
  "Registry": "Registro",
  "Related identities are not automatically interchangeable.": "Las identidades relacionadas no son intercambiables automáticamente.",
  "Related part": "Pieza relacionada",
  "Release configuration": "Publicar configuración",
  "Release each selected child revision before releasing this assembly.": "Publique cada revisión de componente seleccionada antes de este conjunto.",
  "Release the assembly revision before releasing this configuration.": "Publique la revisión del conjunto antes de esta configuración.",
  "Released": "Publicada",
  "Released arm baseline": "Línea base publicada del brazo",
  "Released configurations cannot be changed. Create a new configuration.": "Las configuraciones publicadas no se pueden cambiar. Cree una nueva.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Las definiciones publicadas no cambian. Cree otra revisión para modificarlas.",
  "Released structures stay unchanged. Create a new revision.": "Las estructuras publicadas no cambian. Cree otra revisión.",
  "Reload saved preferences": "Recargar preferencias guardadas",
  "Reload structure": "Recargar estructura",
  "Remove": "Quitar",
  "Remove access": "Retirar acceso",
  "Remove alias": "Quitar número externo",
  "Remove external alias?": "¿Quitar número externo?",
  "Remove from assembly": "Quitar del conjunto",
  "Remove from assembly?": "¿Quitar del conjunto?",
  "Remove saved search": "Eliminar búsqueda guardada",
  "Remove saved search?": "¿Eliminar búsqueda guardada?",
  "Remove {value0}'s access?": "¿Retirar el acceso de {value0}?",
  "Replace invitation link?": "¿Sustituir enlace de invitación?",
  "Replace link": "Sustituir enlace",
  "Replacement": "Sustitución",
  "Replacement conditions": "Condiciones de sustitución",
  "Results per page": "Resultados por página",
  "Retired": "Retirado",
  "Retry saved change": "Reintentar cambio conservado",
  "Reuse & structure": "Reutilización y estructura",
  "Reuse parts": "Reutilizar piezas",
  "Reuse source": "Origen de reutilización",
  "Rev": "Rev.",
  "Revision": "Revisión",
  "Revision and configuration numbers must be positive.": "Los números de revisión y configuración deben ser positivos.",
  "Revision structures are selected by revision, not by project snapshot.": "Las estructuras se eligen por revisión, no por instantánea del proyecto.",
  "Revisions": "Revisiones",
  "Revoke invitation": "Revocar invitación",
  "Revoke invitation?": "¿Revocar invitación?",
  "Right hand": "Mano derecha",
  "Riveted": "Remachado",
  "Riveted assembly": "Conjunto remachado",
  "Riveted chest panel": "Panel pectoral remachado",
  "Robot numbering guide": "Guía de numeración del robot",
  "Same assembly and revision, different frozen selections.": "Mismo conjunto y revisión, distintas selecciones fijadas.",
  "Same cover identity": "Misma identidad de cubierta",
  "Save": "Guardar",
  "Save as a new search": "Guardar como búsqueda nueva",
  "Save changes": "Guardar cambios",
  "Save configuration": "Guardar configuración",
  "Save project": "Guardar proyecto",
  "Save replacement": "Guardar sustitución",
  "Save search": "Guardar búsqueda",
  "Saved change recovery": "Recuperación del cambio guardado",
  "Saved searches": "Búsquedas guardadas",
  "Saving…": "Guardando…",
  "Search": "Buscar",
  "Search columns and order": "Columnas y orden de búsqueda",
  "Search company parts": "Buscar piezas de la empresa",
  "Search filters": "Filtros de búsqueda",
  "Search name": "Nombre de búsqueda",
  "Search order": "Orden de búsqueda",
  "Search part numbers or names": "Buscar números o nombres de piezas",
  "Searching…": "Buscando…",
  "Search…": "Buscar…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Seleccione una cubierta para ver su número en el robot. Una geometría parecida puede tener distinto material y definición.",
  "Select a revision of this assembly.": "Seleccione una revisión de este conjunto.",
  "Select a variant code registered in this company.": "Seleccione un código de variante registrado en esta empresa.",
  "Select an assembly revision.": "Seleccione una revisión del conjunto.",
  "Select an exact child revision.": "Seleccione una revisión exacta del componente.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Seleccione al menos un uso de componente antes de publicar la configuración.",
  "Selected engineering definition": "Definición técnica seleccionada",
  "Selected revision": "Revisión seleccionada",
  "Send this link to": "Envíe este enlace a",
  "Separable": "Separable",
  "Separable assembly": "Conjunto desmontable",
  "Several parts use this external alias. Search it and choose the correct part.": "Varias piezas usan este número externo. Búsquelo y elija la pieza correcta.",
  "Show V": "Mostrar V",
  "Show all company parts": "Mostrar todas las piezas de la empresa",
  "Show {column}": "Mostrar {column}",
  "Showing the first": "Se muestran los primeros",
  "Shown in product version V": "Mostrado en la versión de producto V",
  "Sign in first.": "Inicie sesión primero.",
  "Sign in to continue.": "Inicie sesión para continuar.",
  "Sign in to your engineering workspace.": "Acceda a su espacio de ingeniería.",
  "Sign in with the Google account named on this invitation.": "Acceda con la cuenta de Google indicada en la invitación.",
  "Sign out": "Cerrar sesión",
  "Signing in…": "Iniciando sesión…",
  "Skip to content": "Ir al contenido",
  "Sort": "Orden",
  "Standard position meanings cannot be changed.": "No se pueden cambiar los significados de las posiciones estándar.",
  "State": "Estado",
  "Structure": "Estructura",
  "Structure snapshot": "Instantánea de estructura",
  "Structure snapshot not found.": "No se encontró la instantánea de estructura.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Cambie a V2: las manos y los pasadores reutilizados conservan sus números V1. Solo la cámara nueva recibe un número V2. ROBOT es el código del proyecto; V1/V2 son versiones del producto, no revisiones de piezas.",
  "Switch to {value0} appearance": "Cambiar al tema {value0}",
  "Table density": "Densidad de tabla",
  "That record was not found in this company.": "No se encontró este registro en la empresa.",
  "The corrected identifier must differ from the current identifier.": "El identificador corregido debe ser distinto del actual.",
  "The correction creates duplicate identifiers.": "La corrección genera identificadores duplicados.",
  "The identifier number is outside the supported positive integer range.": "El número del identificador está fuera del intervalo de enteros positivos admitido.",
  "The next number changed. Review the updated preview, then issue again.": "El siguiente número cambió. Revise la vista previa y vuelva a asignarlo.",
  "The number is allocated within its prefix:": "El número se asigna dentro de su prefijo:",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "La pieza antigua conserva su ficha. Ejemplo: la cubierta de repuesto solo encaja con adaptador. No implica el sentido inverso; una sustitución no es un alias.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "La definición publicada anterior sigue disponible; un número sin cualificar identifica la pieza, no la «última revisión».",
  "The part is saved in the company registry.": "La pieza se ha guardado en el registro de la empresa.",
  "The pending invitation for": "La invitación pendiente de",
  "The prefix is ROBOT-V1.2A.": "El prefijo es ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "La familia relacionada debe tener la misma versión de producto y el mismo padre de origen.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "No se pudo completar la solicitud. Reintente o recargue; confirme los cambios pendientes antes de volver a editar.",
  "The request could not be read. Check your input and try again.": "No se pudo leer la solicitud. Revise los datos y reintente.",
  "The revision and configuration select different assembly baselines.": "La revisión y la configuración seleccionan distintas líneas base del conjunto.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "Misma forma de cubierta: aluminio plateado a la izquierda, fibra de carbono tejida a la derecha",
  "The selected part may replace": "La pieza seleccionada puede sustituir a",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "Compartir número de familia no implica intercambiabilidad. «Sin lado» omite el calificador; crear un lado no crea el otro.",
  "This PIN was not found in the selected company.": "No se encontró este PIN en la empresa seleccionada.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "Esta línea base usa varias revisiones del componente. Especifique !REV.",
  "This change conflicts with an existing record. Reload and review your changes.": "El cambio entra en conflicto con un registro existente. Recargue y revise.",
  "This child revision is not in the selected parent baseline.": "Esta revisión del componente no está en la línea base padre seleccionada.",
  "This code was registered elsewhere. Review its meaning before using it.": "Este código se registró en otra sesión. Revise su significado antes de usarlo.",
  "This configuration is already released.": "Esta configuración ya está publicada.",
  "This destination is read-only or the revision is unavailable.": "El destino es de solo lectura o la revisión no está disponible.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "Este número pertenece a otra familia. Cree explícitamente una identidad relacionada.",
  "This identifier is reserved by a historical rename.": "Este identificador está reservado por un cambio de nombre histórico.",
  "This invitation has expired or been revoked.": "Esta invitación ha caducado o se ha revocado.",
  "This invitation has expired, was replaced, or is no longer pending.": "La invitación ha caducado, se ha sustituido o ya no está pendiente.",
  "This invitation is no longer pending.": "Esta invitación ya no está pendiente.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "Es el siguiente número disponible, no una reserva. Se comprueba al asignarlo. Si alguien lo usa antes, el formulario sigue abierto con una vista previa actualizada.",
  "This occurrence would create a structure cycle.": "Este uso crearía un ciclo en la estructura.",
  "This part number already exists. Choose a different variant or position.": "Este número de pieza ya existe. Elija otra variante o posición.",
  "This person is already a member. Change their role in Members.": "Esta persona ya es miembro. Cambie su rol en Miembros.",
  "This product version number is already assigned.": "Este número de versión de producto ya está asignado.",
  "This project code already exists.": "Este código de proyecto ya existe.",
  "This record changed. Reload it before saving again.": "El registro cambió. Recárguelo antes de guardar.",
  "This released configuration does not exist.": "Esta configuración publicada no existe.",
  "This replacement direction already exists.": "Este sentido de sustitución ya existe.",
  "This revision does not exist.": "Esta revisión no existe.",
  "This revision is already released.": "Esta revisión ya está publicada.",
  "This saved search belongs to another person.": "Esta búsqueda guardada pertenece a otra persona.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "Actualiza los prefijos del proyecto. Las identidades controladas conservan redirecciones históricas.",
  "Time zone": "Zona horaria",
  "Try again": "Reintentar",
  "Two hands, two identities.": "Dos manos, dos identidades.",
  "Two occurrences, one part": "Dos usos, una pieza",
  "Unit": "Unidad",
  "Unsaved search": "Búsqueda sin guardar",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Use PROJECT-V1 seguido de nodos de identidad sin ceros iniciales.",
  "Use a positive product version number.": "Use un número de versión de producto positivo.",
  "Use a positive, unpadded family number.": "Use un número de familia positivo sin ceros iniciales.",
  "Use a whole number for the search filter.": "Use un número entero en el filtro de búsqueda.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Código en mayúsculas que empiece por letra, con letras, números o guiones, máximo 32 caracteres.",
  "Use code": "Usar código",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Use número/tipo, opcionalmente !VARIANT y #POSITION, luego !REV y !CFG en ese orden. No se permiten ceros iniciales ni calificadores con dos puntos.",
  "Using this pin in V2 or another project in the same company keeps": "El uso de este pasador en V2 u otro proyecto de la empresa conserva",
  "V1 tells you where a part was first numbered.": "V1 indica dónde se numeró la pieza por primera vez.",
  "Variant code": "Código de variante",
  "Variant codes": "Códigos de variantes",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Los códigos de variante contienen mayúsculas y no pueden comenzar por REV o CFG.",
  "Variants & replacements": "Variantes y sustituciones",
  "Version name": "Nombre de versión",
  "Version name (optional)": "Nombre de versión (opcional)",
  "Version number": "Número de versión",
  "View parts": "Ver piezas",
  "Viewer": "Lector",
  "Wait for a valid part-number preview.": "Espere una vista previa válida del número de pieza.",
  "Welded": "Soldado",
  "Welded assembly": "Conjunto soldado",
  "Welded torso frame": "Bastidor del torso soldado",
  "Where used": "Dónde se usa",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "Con dependencias controladas, el texto anterior redirige a la pieza renombrada. !REV1 sigue siendo la revisión histórica exacta; se conservan configuraciones y numeración descendiente.",
  "Withdraw permission for": "Retirar permiso a",
  "Withdraw replacement": "Retirar sustitución",
  "Withdraw replacement?": "¿Retirar sustitución?",
  "You are already a member of this company.": "Ya es miembro de esta empresa.",
  "Your form session expired. Refresh your session, then retry the saved change.": "La sesión del formulario caducó. Actualícela y reintente el cambio conservado.",
  "Your preferences changed. Reload before saving again.": "Sus preferencias cambiaron. Recárguelas antes de guardar.",
  "across this company": "en toda la empresa",
  "and": "y",
  "at {value0}": "en {value0}",
  "dark": "oscuro",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "distinguen las formas derecha e izquierda. Las etiquetas señalan las manos del robot, no los lados del observador.",
  "from": "de",
  "from this structure? The original part remains in the company registry.": "de esta estructura? La pieza original permanece en el registro de la empresa.",
  "in this example.": "en este ejemplo.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "es el tipo constructivo, no una revisión. P es una pieza sin componentes controlados; A, W, G y R son conjuntos unidos de distintas formas.",
  "issued.": "asignado.",
  "light": "claro",
  "match": "coincidencia",
  "matches": "coincidencias",
  "mm": "mm",
  "of": "de",
  "only under the stated conditions.": "solo bajo las condiciones indicadas.",
  "parts. Search the company to find additional matches.": "piezas. Busque en la empresa para obtener más coincidencias.",
  "to replace": "para sustituir a",
  "will lose access to every project and part in this company.": "perderá el acceso a todos los proyectos y piezas de esta empresa.",
  "will no longer work.": "dejará de funcionar.",
  "{field} must contain {minimum}–{maximum} characters.": "{field} debe contener entre {minimum} y {maximum} caracteres.",
  "{value0} added to {value1}.": "{value0} añadido a {value1}.",
  "{value0} code": "Código {value0}",
  "{value0} cover example": "Ejemplo de cubierta {value0}",
  "{value0} editor": "Editor de {value0}",
  "{value0} meaning": "Significado de {value0}",
  "{value0} · Rev {value1}": "{value0} · Rev. {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· 1 unidad cada uno",
  "· Refine your search for other matches.": "· Refine la búsqueda para obtener más coincidencias.",
  "· Revision {value0}": "· Revisión {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF cambia la identidad, no la revisión.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "¿Su definición y sus usos exactos quedarán fijados. Los cambios posteriores requerirán otra revisión.",
  "Accept invitation": "Aceptar invitación",
  "Accepting…": "Aceptando…",
  "Actions": "Acciones",
  "Actions for {value0}": "Acciones para {value0}",
  "Add description": "Añadir descripción",
  "Add external alias": "Añadir número externo",
  "An origin parent is selected.": "Se ha seleccionado un padre de origen.",
  "Applicability / effectivity": "Aplicabilidad / vigencia",
  "Apply identity correction": "Aplicar corrección de identidad",
  "Assembly revision": "Revisión del conjunto",
  "Both covers share": "Ambas cubiertas comparten",
  "Change role": "Cambiar rol",
  "Checking number…": "Comprobando número…",
  "Child REV": "Rev. del componente",
  "Choose a project": "Elegir un proyecto",
  "Choose a revision to inspect its exact definition.": "Elija una revisión para ver su definición exacta.",
  "Choose a revision to view its exact structure.": "Elija una revisión para ver su estructura exacta.",
  "Choose an assembly in the selected product version.": "Elija un conjunto de esta versión de producto.",
  "Choose an exact assembly revision.": "Elija una revisión exacta del conjunto.",
  "Choose another company": "Elegir otra empresa",
  "Collapse": "Contraer",
  "Company access unavailable": "Acceso a la empresa no disponible",
  "Copied.": "Copiado.",
  "Copy link": "Copiar enlace",
  "Copy was unavailable. Select the link and copy it manually.": "No se pudo copiar. Seleccione el enlace y cópielo manualmente.",
  "Correct identity": "Corregir identidad",
  "Custom position…": "Posición personalizada…",
  "Definition": "Definición",
  "Details for {value0}": "Detalles de {value0}",
  "Edit": "Editar",
  "Edit alias {value}": "Editar número externo {value}",
  "Edit definition": "Editar definición",
  "Edit external alias": "Editar número externo",
  "Empty definition": "Definición vacía",
  "Expand": "Expandir",
  "Family number": "Número de familia",
  "Freeze CFG": "Fijar CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "El acceso de Google no está configurado. El administrador debe restaurar la configuración.",
  "Identity": "Identidad",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "En esta empresa de ejemplo, CF significa «fibra de carbono». Otras empresas pueden registrar otro significado.",
  "Include selected revision": "Incluir revisión seleccionada",
  "Invitations": "Invitaciones",
  "Join": "Unión",
  "Left": "Izquierda",
  "Next": "Siguiente",
  "No child parts.": "No hay piezas hijas.",
  "No companies yet.": "Aún no hay empresas.",
  "No configurations yet.": "Aún no hay configuraciones.",
  "No external aliases.": "No hay números externos.",
  "No invitations.": "No hay invitaciones.",
  "No matching choices.": "No hay opciones coincidentes.",
  "No matching parts.": "No hay piezas coincidentes.",
  "No parts in this structure yet.": "Aún no hay piezas en esta estructura.",
  "No product versions in this project.": "No hay versiones de producto en este proyecto.",
  "No product versions yet.": "Aún no hay versiones de producto.",
  "No projects yet.": "Aún no hay proyectos.",
  "No replacement relationships.": "No hay relaciones de sustitución.",
  "No variant code": "Sin código de variante",
  "No variant codes registered.": "No hay códigos de variante registrados.",
  "Not reserved": "No reservado",
  "Numbered directly under the product version.": "Numerado directamente bajo la versión de producto.",
  "Open assembly {value0}": "Abrir conjunto {value0}",
  "Open resolved configuration": "Abrir configuración resuelta",
  "Origin product version": "Versión de producto de origen",
  "Other positions": "Otras posiciones",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Otras posiciones añaden calificadores: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR y #TOP/#MIDVERT/#BOTTOM. Los dos puntos medios pertenecen a ejes distintos. La empresa define los códigos personalizados. No es la ubicación de una pieza reutilizada en un conjunto.",
  "Other positions…": "Otras posiciones…",
  "Page {page} of {pages}": "Página {page} de {pages}",
  "Part / P/N": "Pieza / número",
  "Part section not found.": "No se encontró la sección de pieza.",
  "Parts in {value0}": "Piezas en {value0}",
  "Person": "Persona",
  "Piece parts have no child structure.": "Las piezas individuales no tienen estructura hija.",
  "Position for occurrence {value0}": "Posición del uso {value0}",
  "Previous": "Anterior",
  "Product root": "Raíz del producto",
  "Product structure": "Estructura del producto",
  "Qty": "Cant.",
  "Quantity for occurrence {value0}": "Cantidad del uso {value0}",
  "Quantity for {value0} {value1}": "Cantidad de {value0} {value1}",
  "Quantity saved for {value0}.": "Cantidad de {value0} guardada.",
  "Read-only access": "Acceso de solo lectura",
  "Reason for correction": "Motivo de corrección",
  "Registered variant": "Variante registrada",
  "Release": "Publicar",
  "Release revision": "Publicar revisión",
  "Remove alias {value}": "Quitar número externo {value}",
  "Remove from assembly {value0} {value1}": "Quitar {value0} {value1} del conjunto",
  "Remove selected occurrence": "Quitar uso seleccionado",
  "Remove {value0}'s access": "Retirar acceso de {value0}",
  "Replace invitation link for {value0}": "Sustituir enlace de invitación de {value0}",
  "Reset quantity for {value0}": "Restablecer cantidad de {value0}",
  "Resolved definition: REV": "Definición resuelta: REV",
  "Results: {count}": "Resultados: {count}",
  "Retry preview": "Reintentar vista previa",
  "Revoke": "Revocar",
  "Revoke invitation for {value0}": "Revocar invitación de {value0}",
  "Right": "Derecha",
  "Role": "Rol",
  "Same family number, different identities.": "Mismo número de familia, distintas identidades.",
  "Save quantity for {value0}": "Guardar cantidad de {value0}",
  "Search pages": "Páginas de búsqueda",
  "Source product version": "Versión de producto de origen",
  "Source project": "Proyecto de origen",
  "Start from": "Empezar desde",
  "Structural class": "Tipo constructivo",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "La invitación se creó, pero su enlace único no puede volver a mostrarse. Use «Sustituir enlace» para generar otro.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "El enlace de invitación está incompleto. Pida otro al propietario de la empresa.",
  "This part is not used in a structure or configuration.": "Esta pieza no se usa en ninguna estructura ni configuración.",
  "This structure is read-only. Choose a draft revision to edit.": "Esta estructura es de solo lectura. Elija una revisión en borrador para editarla.",
  "Unit & position": "Unidad y posición",
  "Unit for occurrence {value0}": "Unidad del uso {value0}",
  "Unspecified": "Sin especificar",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Las asignaciones sin uso se corrigen directamente. Las identidades controladas se renombran de forma atómica con redirecciones históricas; revisiones, configuraciones y usos siguen vinculados.",
  "Use product-version root": "Usar raíz de la versión de producto",
  "Variant": "Variante",
  "Versions": "Versiones",
  "You do not have company access yet. Open an invitation from a company owner.": "Aún no tiene acceso a una empresa. Abra una invitación de su propietario.",
  "Your account does not have access to this company.": "Su cuenta no tiene acceso a esta empresa.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "y sus revisiones exactas de componentes? El conjunto y todas las revisiones deben estar publicados.",
  "as": "como",
  "because the new cover was explicitly numbered as related to the existing one.": "porque la nueva cubierta se numeró explícitamente como relacionada con la existente.",
  "may replace": "puede sustituir a",
  "using": "usando",
  "· Expires": "· Caduca",
  "Sign in again": "Volver a iniciar sesión",
  "Refresh session": "Actualizar sesión",
  "Connection interrupted. Check the saved change before making another edit.": "Conexión interrumpida. Revise el cambio conservado antes de volver a editar.",
  "The request could not be completed.": "No se pudo completar la solicitud.",
  "Resolve the saved change shown above before making another edit.": "Resuelva el cambio conservado antes de volver a editar.",
  "Browser storage is unavailable. Enable it before saving a change.": "El almacenamiento del navegador no está disponible. Actívelo antes de guardar.",
  "No position": "Sin posición",
  "Not specified.": "Sin especificar.",
  "No description.": "Sin descripción.",
  "Field": "Campo",
  "Choose…": "Elegir…",
  "Choose": "Elegir",
  "Complete {field}.": "Complete {field}.",
  "Check the value of {field}.": "Revise el valor de {field}.",
  "Do not submit another edit until this change is confirmed.": "No envíe otra edición hasta confirmar este cambio.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 conserva la cubierta REV1; CFG2 elige REV2. Una configuración no es un número nuevo y solo se aplica a conjuntos.",
  "No variant": "Sin variante",
  "Company created": "Empresa creada",
  "Company updated": "Empresa actualizada",
  "Variant code registered": "Código de variante registrado",
  "Position code registered": "Código de posición registrado",
  "Role changed": "Rol cambiado",
  "Membership removed": "Miembro retirado",
  "Invitation created": "Invitación creada",
  "Invitation link replaced": "Enlace de invitación sustituido",
  "Invitation revoked": "Invitación revocada",
  "Invitation accepted": "Invitación aceptada",
  "Revision created": "Revisión creada",
  "Revision definition updated": "Definición de revisión actualizada",
  "Revision released": "Revisión publicada",
  "Structure occurrence added": "Uso de pieza añadido",
  "Structure occurrence updated": "Uso de pieza actualizado",
  "Structure occurrence removed": "Uso de pieza retirado",
  "Configuration created": "Configuración creada",
  "Configuration updated": "Configuración actualizada",
  "Configuration released": "Configuración publicada",
  "Replacement recorded": "Sustitución registrada",
  "Replacement withdrawn": "Sustitución retirada",
  "Project created": "Proyecto creado",
  "Project updated": "Proyecto actualizado",
  "Product version created": "Versión de producto creada",
  "Product version updated": "Versión de producto actualizada",
  "Part issued": "Número de pieza asignado",
  "Part details updated": "Detalles de pieza actualizados",
  "alias-added": "Número externo añadido",
  "alias-edited": "Número externo editado",
  "alias-removed": "Número externo eliminado",
  "Identity renamed": "Identidad renombrada",
  "Assignment corrected": "Asignación corregida",
  "North": "Norte",
  "South": "Sur",
  "West": "Oeste",
  "East": "Este",
  "Front": "Delante",
  "Rear": "Detrás",
  "Mid": "Medio",
  "Top": "Arriba",
  "Bottom": "Abajo",
  "Side": "Lado",
  "North / south": "Norte / sur",
  "West / east": "Oeste / este",
  "Front / rear": "Delante / detrás",
  "Top / bottom": "Arriba / abajo",
  "Custom": "Personalizado",
  "Family, not an orderable P/N": "Familia, no un número que se pueda pedir",
  "Pending": "Pendiente",
  "Accepted": "Aceptada",
  "Revoked": "Revocada",
  "Expired": "Caducada",
  "Edit revision definition": "Editar definición de revisión",
  "Release revision?": "¿Liberar revisión?",
  "Release configuration?": "¿Liberar configuración?",
  "A complete SHA-256 checksum is required.": "Se requiere una suma de comprobación SHA-256 completa.",
  "Add comment": "Añadir comentario",
  "Add file": "Añadir archivo",
  "All": "Todos",
  "Applicability": "Aplicabilidad",
  "Applicability must refer to a configuration of the owning part.": "La aplicabilidad debe hacer referencia a una configuración de la pieza a la que pertenece el documento.",
  "Applicability must refer to a revision of the owning part.": "La aplicabilidad debe hacer referencia a una revisión de la pieza a la que pertenece el documento.",
  "Applicability notes": "Notas de aplicabilidad",
  "Attachment": "Adjunto",
  "Cancel upload": "Cancelar carga",
  "Cancelled": "Cancelada",
  "Checking file…": "Comprobando archivo…",
  "Choose Draft or Issued status.": "Elija el estado «Borrador» o «Publicada».",
  "Choose Source, Rendition or Attachment.": "Elija «Fuente», «Versión de consulta» o «Adjunto».",
  "Choose a draft document or production job for this file.": "Elija un borrador de documento o una orden de producción para este archivo.",
  "Choose a file of this revision.": "Elija un archivo de esta revisión.",
  "Choose a registered document type.": "Elija un tipo de documento registrado.",
  "Choose a supported document owner.": "Elija un propietario de documento compatible.",
  "Choose a valid results page and a positive page size.": "Elija una página de resultados válida y un número positivo de resultados por página.",
  "Choose an issued revision of this document.": "Elija una revisión publicada de este documento.",
  "Choose the viewed revision of this document.": "Elija la revisión de este documento que está consultando.",
  "Choose this company as the document owner.": "Elija esta empresa como propietaria del documento.",
  "Clear applicability references": "Borrar referencias de aplicabilidad",
  "Comment": "Comentario",
  "Comment history": "Historial del comentario",
  "Comment removed": "Comentario eliminado",
  "Copy this revision into a shared editable draft?": "¿Copiar esta revisión en un borrador compartido editable?",
  "Create document": "Crear documento",
  "Create shared draft": "Crear borrador compartido",
  "Deleted comments retain their history and cannot be edited.": "Los comentarios eliminados conservan su historial y no se pueden editar.",
  "Discussion": "Debate",
  "Document comment added": "Comentario añadido al documento",
  "Document comment deleted": "Comentario del documento eliminado",
  "Document comment edited": "Comentario del documento editado",
  "Document created": "Documento creado",
  "Document draft created": "Borrador del documento creado",
  "Document draft updated": "Borrador del documento actualizado",
  "Document file": "Archivo del documento",
  "Document file linked": "Archivo vinculado al documento",
  "Document file unlinked": "Vínculo del archivo con el documento eliminado",
  "Document files published": "Archivos del documento compartidos públicamente",
  "Document files unpublished": "Acceso público a los archivos del documento revocado",
  "Document information": "Información del documento",
  "Document issued": "Documento publicado",
  "Document number": "Número del documento",
  "Document reader": "Visor de documentos",
  "Document type": "Tipo de documento",
  "Document type registered": "Tipo de documento registrado",
  "Documents": "Documentos",
  "Download {name}": "Descargar {name}",
  "Edit comment": "Editar comentario",
  "Edit draft": "Editar borrador",
  "Edit history": "Historial de cambios",
  "Exact engineering applicability": "Aplicabilidad técnica exacta",
  "Exact revision": "Revisión exacta",
  "File": "Archivo",
  "File name": "Nombre del archivo",
  "File purpose": "Uso del archivo",
  "File size must be between 1 byte and 20 GiB.": "El tamaño del archivo debe estar entre 1 byte y 20 GiB.",
  "File storage is not configured.": "El almacenamiento de archivos no está configurado.",
  "File unavailable": "Archivo no disponible",
  "Files": "Archivos",
  "Files available to anyone with the public link": "Archivos disponibles para cualquier persona con el enlace público",
  "Files can only be added to a draft document.": "Solo se pueden añadir archivos a un borrador de documento.",
  "Identifier filter": "Filtro por identificador",
  "Issue revision": "Publicar revisión",
  "Issue this exact revision? Its metadata and files will become immutable.": "¿Publicar esta revisión exacta? Sus metadatos y archivos ya no se podrán modificar.",
  "Issued": "Publicada",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Las revisiones publicadas son inmutables. Cree un borrador compartido para hacer cambios.",
  "Link at least one verified file before issuing.": "Vincule al menos un archivo verificado antes de publicar.",
  "New file": "Archivo nuevo",
  "No comments yet.": "Aún no hay comentarios.",
  "No files in this revision.": "No hay archivos en esta revisión.",
  "No published files.": "No hay archivos compartidos públicamente.",
  "No revisions available.": "No hay revisiones disponibles.",
  "Only an unfinished upload can be cancelled.": "Solo se puede cancelar una carga sin finalizar.",
  "Only issued files can be published.": "Solo se pueden compartir públicamente los archivos de revisiones publicadas.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Solo se pueden vincular o publicar archivos inmutables cuya longitud y suma SHA-256 se hayan verificado.",
  "Open public link": "Abrir enlace público",
  "Owner kind": "Tipo de propietario",
  "Page {page} · {count} documents": "Página {page} · Documentos: {count}",
  "Part revision": "Revisión de la pieza",
  "Pause": "Pausar",
  "Paused": "En pausa",
  "Preview is not available for this file. Download it instead.": "La vista previa de este archivo no está disponible. Descárguelo.",
  "Preview unavailable. Download the file to view it.": "Vista previa no disponible. Descargue el archivo para verlo.",
  "Public description": "Descripción pública",
  "Public links": "Enlaces públicos",
  "Public title": "Título público",
  "Publication not found.": "No se encontró la publicación pública.",
  "Publish selected files": "Compartir públicamente los archivos seleccionados",
  "Published document not found.": "No se encontró el documento compartido públicamente.",
  "Published file not found.": "No se encontró el archivo compartido públicamente.",
  "Register document type": "Registrar tipo de documento",
  "Reload revision": "Volver a cargar la revisión",
  "Remove comment": "Eliminar comentario",
  "Remove file": "Quitar archivo",
  "Remove this comment? Its edit history is retained.": "¿Eliminar este comentario? Se conservará su historial de cambios.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "¿Quitar este archivo del borrador? Las revisiones publicadas anteriormente conservarán sus archivos.",
  "Remove {name}": "Quitar {name}",
  "Rendition": "Versión de consulta",
  "Resume this upload with the recorder who started it.": "Reanude esta carga con la persona encargada del registro que la inició.",
  "Resume upload": "Reanudar carga",
  "Revision unavailable": "Revisión no disponible",
  "Revision {number}": "Revisión {number}",
  "Revision {number} · {status}": "Revisión {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Buscar documentos",
  "Select distinct issued files to publish.": "Seleccione archivos distintos de una revisión publicada para compartirlos públicamente.",
  "Select files from this exact issued revision.": "Seleccione archivos de esta revisión publicada exacta.",
  "Select the same file to resume this upload.": "Seleccione el mismo archivo para reanudar esta carga.",
  "Source": "Fuente",
  "Status": "Estado",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "¿Impedir el acceso posterior mediante este enlace público? Las copias ya descargadas no se eliminarán.",
  "That document revision was not found in this company.": "No se encontró esa revisión del documento en esta empresa.",
  "The configuration must select the exact applicability revision.": "La configuración debe seleccionar la revisión exacta indicada por la aplicabilidad.",
  "The document input changed during capture. Retry the same request.": "Los datos del documento cambiaron durante el registro. Vuelva a intentar la misma solicitud.",
  "The file upload is not complete.": "La carga del archivo no ha finalizado.",
  "The issued files no longer match their immutable manifest.": "Los archivos publicados ya no coinciden con su manifiesto inmutable.",
  "The issued manifest failed integrity verification.": "La verificación de integridad del manifiesto publicado ha fallado.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "La suma de comprobación del archivo cargado no coincide. Cancele esta carga y vuelva a seleccionar el archivo original.",
  "The uploaded file is unavailable.": "El archivo cargado no está disponible.",
  "The verified file must belong to this document.": "El archivo verificado debe pertenecer a este documento.",
  "This comment is already deleted.": "Este comentario ya se ha eliminado.",
  "This document already has a shared draft.": "Este documento ya tiene un borrador compartido.",
  "This document numbering sequence is exhausted.": "La secuencia de numeración de estos documentos se ha agotado.",
  "This file is not available.": "Este archivo no está disponible.",
  "This file is unavailable. Contact the company owner.": "Este archivo no está disponible. Contacte con el propietario de la empresa.",
  "This revision changed. Reload it before publishing.": "Esta revisión ha cambiado. Vuelva a cargarla antes de compartir sus archivos públicamente.",
  "This upload cannot be verified.": "Esta carga no se puede verificar.",
  "This upload is no longer writable.": "Ya no se pueden escribir datos en esta carga.",
  "This upload was not found.": "No se encontró esta carga.",
  "Title": "Título",
  "Title filter": "Filtro por título",
  "Type code": "Código del tipo",
  "Type name": "Nombre del tipo",
  "Unpublish": "Revocar acceso público",
  "Unpublished": "Acceso público revocado",
  "Upload file": "Cargar archivo",
  "Uploaded": "Cargada",
  "Uploading…": "Cargando…",
  "Use a file name without a path or control characters.": "Use un nombre de archivo sin ruta ni caracteres de control.",
  "Use a file name without directory separators.": "Use un nombre de archivo sin separadores de directorios.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Use un código de tipo formado por letras latinas mayúsculas y dígitos que empiece por una letra.",
  "Verified": "Verificada",
  "Verifying file…": "Verificando archivo…",
  "View draft": "Ver borrador",
  "file-upload-created": "Carga de archivo creada",
  "file-verified": "Archivo verificado",
  "{bytes} bytes": "{bytes} bytes",
  "No matching documents.": "No hay documentos coincidentes.",
  "No documents yet.": "Aún no hay documentos.",
  "The revision’s applicability details could not be loaded. Try again.": "No se pudieron cargar los detalles de aplicabilidad de la revisión. Vuelva a intentarlo.",
  "Comment authors could not be loaded. Try again.": "No se pudieron cargar los autores de los comentarios. Vuelva a intentarlo.",
  "Comment history authors could not be loaded. Try again.": "No se pudieron cargar los autores de los cambios del comentario. Vuelva a intentarlo.",
  "Choose a saved search": "Elegir una búsqueda guardada",
  "This saved search belongs to another person or collection.": "Esta búsqueda guardada pertenece a otra persona o colección.",
  "Choose a saved parts search.": "Elija una búsqueda de piezas guardada.",
  "Supply document search filters.": "Indique los filtros de búsqueda de documentos.",
  "Pages": "Páginas",
  "{from}–{to} of {total}": "{from}–{to} de {total}",
  "Choose lot": "Elegir lote",
  "Choose material": "Elegir material",
  "No matches": "Sin coincidencias",
  "Stock": "Existencias",
  "Lots": "Lotes",
  "Materials": "Materiales",
  "Supplier": "Proveedor",
  "Material identifier": "Identificador del material",
  "Specification": "Especificación",
  "Reload latest versions": "Recargar las versiones más recientes",
  "Edit material": "Editar material",
  "Create material revision": "Crear revisión del material",
  "Edit material revision": "Editar revisión del material",
  "Release material revision": "Publicar revisión del material",
  "Create lot": "Crear lote",
  "Choose an exact material revision.": "Elija una revisión concreta del material.",
  "Lot identifier": "Identificador del lote",
  "Balances": "Saldos de existencias",
  "No stock recorded": "No hay existencias registradas",
  "Genealogy": "Genealogía de lotes",
  "No linked lots": "No hay lotes vinculados",
  "To": "A",
  "Reversed": "Anulado",
  "Movement details": "Detalles del movimiento",
  "Record history": "Historial del registro",
  "Movements": "Movimientos de existencias",
  "Movement type": "Tipo de movimiento",
  "No movements recorded": "No hay movimientos registrados",
  "Original movement": "Movimiento original",
  "Replaced movement": "Movimiento sustituido",
  "Reversal": "Anulación",
  "Reverse movement": "Anular movimiento",
  "Record replacement": "Registrar sustitución",
  "Movement warnings unavailable": "Avisos de movimiento no disponibles",
  "Warnings": "Avisos",
  "Actual quantity": "Cantidad real",
  "Location": "Ubicación",
  "Disposition": "Estado de disposición",
  "Use balance location": "Usar la ubicación del saldo",
  "Wait for the latest balances.": "Espere a que se carguen los saldos actuales.",
  "Choose a lot for every quantity.": "Elija un lote para cada cantidad.",
  "Source {number}": "Origen {number}",
  "Remove source": "Quitar origen",
  "Add source": "Añadir origen",
  "Output {number}": "Salida {number}",
  "Remove output": "Quitar salida",
  "Add output": "Añadir salida",
  "Destination location": "Ubicación de destino",
  "Source reference": "Referencia de origen",
  "Reason": "Motivo",
  "Reload latest balances": "Recargar los saldos actuales",
  "Receipt": "Recepción",
  "Accept": "Aceptar",
  "Quarantine": "Poner en cuarentena",
  "Transfer": "Traslado",
  "Consume": "Consumir",
  "Scrap": "Desechar",
  "Split": "Dividir",
  "Merge": "Combinar",
  "MaterialLots": "Lotes de materiales",
  "Receipts": "Recepciones",
  "Create material": "Crear material",
  "Search lots": "Buscar lotes",
  "Search materials": "Buscar materiales",
  "Select a lot": "Seleccione un lote",
  "Select a material": "Seleccione un material",
  "Supplier reference": "Referencia del proveedor",
  "Supplier lot reference": "Referencia del lote del proveedor",
  "Material created": "Material creado",
  "Material renamed": "Material renombrado",
  "Material revision created": "Revisión del material creada",
  "Material revision edited": "Revisión del material editada",
  "Material revision released": "Revisión del material publicada",
  "Lot created": "Lote creado",
  "Correction": "Corrección",
  "Record updated": "Registro actualizado",
  "All movements": "Todos los movimientos",
  "Quarantined": "En cuarentena",
  "Not recorded": "No registrado",
  "No matching records.": "No hay registros coincidentes.",
  "Page": "Página",
  "Evidence warnings": "Avisos sobre evidencias",
  "Production": "Producción",
  "Create job": "Crear orden de fabricación",
  "Routes": "Rutas de fabricación",
  "Search jobs": "Buscar órdenes de fabricación",
  "Clear part filter": "Borrar filtro de piezas",
  "No jobs found.": "No se encontraron órdenes de fabricación.",
  "Select a job to review or record actual work.": "Seleccione una orden para revisar o registrar el trabajo real.",
  "Change": "Cambiar",
  "Select an exact definition revision.": "Seleccione una revisión concreta de la definición.",
  "Job identifier": "Identificador de la orden",
  "Route input": "Ruta de entrada",
  "Document inputs": "Documentos de entrada",
  "Select route": "Seleccionar ruta",
  "Back": "Volver",
  "Create route": "Crear ruta",
  "Create route revision": "Crear revisión de ruta",
  "Choose another route": "Elegir otra ruta",
  "Inspection expected": "Inspección prevista",
  "Route name": "Nombre de la ruta",
  "Operation": "Operación",
  "Instructions": "Instrucciones",
  "Move up": "Subir",
  "Move down": "Bajar",
  "Remove operation": "Quitar operación",
  "Add operation": "Añadir operación",
  "Serials": "Unidades serializadas",
  "ProductionOutputs": "Salidas de producción",
  "Operations": "Operaciones",
  "Inspections": "Inspecciones",
  "Declarations": "Declaraciones",
  "Back to collection": "Volver a la lista",
  "Recorded at": "Fecha de registro",
  "Created": "Creado",
  "Display columns": "Columnas visibles",
  "Import records": "Importar registros",
  "Preview records": "Previsualizar registros",
  "New preview": "Nueva vista previa",
  "Apply valid rows": "Aplicar filas válidas",
  "Reload preview": "Recargar vista previa",
  "Row {number}": "Fila {number}",
  "Applied": "Aplicado",
  "Apply row": "Aplicar fila",
  "Source name": "Nombre de origen",
  "Record type": "Tipo de registro",
  "Download CSV template": "Descargar plantilla CSV",
  "CSV file": "Archivo CSV",
  "Previous imports": "Importaciones anteriores",
  "Manual entry": "Entrada manual",
  "Choose a CSV file.": "Elija un archivo CSV.",
  "The CSV file exceeds the import size limit.": "El archivo CSV supera el tamaño máximo de importación.",
  "Serial number": "Número de serie",
  "Output source reference": "Referencia de origen de la salida",
  "Step": "Paso",
  "Result": "Resultado",
  "Actual result": "Resultado real",
  "Kind": "Clase",
  "Value": "Valor",
  "Exact configuration": "Configuración concreta",
  "Exact route revision": "Revisión concreta de la ruta",
  "Material definition": "Definición del material",
  "Primary definition": "Definición principal",
  "Route revision": "Revisión de ruta",
  "Record output": "Registrar salida",
  "Record operation": "Registrar operación",
  "Record inspection": "Registrar inspección",
  "Record consumption or component": "Registrar consumo o componente",
  "Declare output": "Declarar estado de la salida",
  "Capture as-built": "Capturar configuración fabricada",
  "Unnamed record": "Registro sin nombre",
  "Serial": "Número de serie",
  "None available": "Ninguno disponible",
  "The selected job was not found in an editable company.": "La orden seleccionada no se encontró en ninguna empresa con permiso de edición.",
  "Offline job": "Orden sin conexión",
  "Download selected job": "Descargar la orden seleccionada",
  "Offline work": "Trabajo sin conexión",
  "Selected job and files saved for offline use.": "La orden seleccionada y sus archivos se guardaron para usarlos sin conexión.",
  "Download": "Descargar",
  "bytes": "bytes",
  "Find material lots": "Buscar lotes de materiales",
  "Find component parts": "Buscar piezas componentes",
  "Correct recorded work": "Corregir trabajo registrado",
  "Save correction": "Guardar corrección",
  "Save offline": "Guardar sin conexión",
  "Wait for evidence to finish saving.": "Espere a que se terminen de guardar las evidencias.",
  "Choose an output with a recorded version.": "Elija una salida con una versión registrada.",
  "Reconnect and load current records before saving a correction.": "Vuelva a conectarse y cargue los registros actuales antes de guardar una corrección.",
  "Confirm that this correction uses the current stock version.": "Confirme que esta corrección usa la versión actual de las existencias.",
  "The original recording is retained. Review current records before submitting a separate correction.": "Se conserva el registro original. Revise los registros actuales antes de enviar una corrección por separado.",
  "Loading current records": "Cargando registros actuales",
  "Current stock": "Existencias actuales",
  "Completed": "Completado",
  "Failed": "Fallido",
  "Skipped": "Omitido",
  "InProgress": "En curso",
  "Passed": "Superado",
  "Inconclusive": "No concluyente",
  "I reviewed the stock conflict and authorize this correction against current stock.": "He revisado el conflicto de existencias y autorizo esta corrección sobre las existencias actuales.",
  "Quality": "Calidad",
  "NotStarted": "No iniciado",
  "Rejected": "Rechazado",
  "As-built": "Configuración fabricada",
  "Evidence file": "Archivo de evidencia",
  "Saving evidence locally": "Guardando evidencias localmente",
  "The correction retains the original evidence attachments.": "La corrección conserva los archivos de evidencia originales.",
  "Reconnect to verify recorder access before continuing.": "Vuelva a conectarse para verificar el acceso de quien registra antes de continuar.",
  "Reconnect as the original offline recorder.": "Vuelva a conectarse con la cuenta que inició el registro sin conexión.",
  "Offline recording access was revoked. Recorded work is retained.": "Se revocó el acceso al registro sin conexión. Se conserva el trabajo registrado.",
  "Reconnect": "Volver a conectar",
  "Loading": "Cargando",
  "No offline job is open. Download a selected production job while connected.": "No hay ninguna orden sin conexión abierta. Descargue una orden de fabricación mientras esté conectado.",
  "Selected job": "Orden seleccionada",
  "Online": "Con conexión",
  "Offline": "Sin conexión",
  "Resume download": "Reanudar descarga",
  "Synchronize": "Sincronizar",
  "Close offline session": "Cerrar sesión sin conexión",
  "Captured operations": "Operaciones capturadas",
  "No route captured": "No se capturó ninguna ruta",
  "Recorded inspections": "Inspecciones registradas",
  "Outputs": "Salidas",
  "No outputs recorded": "No hay salidas registradas",
  "Downloaded files": "Archivos descargados",
  "Material lots": "Lotes de materiales",
  "Record work": "Registrar trabajo",
  "Recorded commands": "Acciones registradas",
  "No local commands recorded": "No hay acciones locales registradas",
  "Retained original; correction recorded": "Original conservado; corrección registrada",
  "Retry unchanged": "Reintentar sin cambios",
  "Saved evidence": "Evidencias guardadas",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Cierre solo cuando se hayan aceptado todo el trabajo registrado y sus evidencias. El historial local seguirá disponible.",
  "Offline storage is unavailable in this browser.": "El almacenamiento sin conexión no está disponible en este navegador.",
  "The offline application could not be downloaded. Try again online.": "No se pudo descargar la aplicación sin conexión. Vuelva a intentarlo conectado.",
  "The offline application is not ready. Reload online and try again.": "La aplicación sin conexión no está lista. Recargue con conexión y vuelva a intentarlo.",
  "An offline update is waiting. Close other registry tabs and reload online.": "Hay una actualización sin conexión pendiente. Cierre las demás pestañas del registro y recargue con conexión.",
  "Verified files": "Archivos verificados",
  "Component part": "Pieza componente",
  "Component serials": "Componentes serializados",
  "Output": "Salida",
  "Reserved serial": "Unidad serializada reservada",
  "Output lot": "Lote de salida",
  "Operation order": "Orden de la operación",
  "Shared run": "Ejecución de producción compartida",
  "Rework of": "Retrabajo de",
  "Inspection": "Inspección",
  "Actual": "Valor real",
  "Operation attempt": "Intento de operación",
  "Material lot": "Lote de material",
  "Component serial": "Componente serializado",
  "Actual revision": "Revisión real",
  "Declaration": "Declaración",
  "Declared state": "Estado declarado",
  "Amends snapshot": "Modifica la instantánea",
  "Attach saved evidence": "Adjuntar evidencias guardadas",
  "preparing": "Preparando",
  "downloading": "Descargando",
  "ready": "Listo",
  "rejected": "Rechazado",
  "closed": "Cerrado",
  "pending": "Pendiente",
  "sending": "Enviando",
  "accepted": "Aceptado",
  "conflict": "Conflicto",
  "staged": "Preparado localmente",
  "uploading": "Subiendo",
  "verified": "Verificado",
  "attached": "Adjuntado",
  "Captured inputs": "Entradas capturadas",
  "Captured route": "Ruta capturada",
  "Planned components": "Componentes previstos",
  "No planned components.": "No hay componentes previstos.",
  "No file evidence recorded.": "No hay archivos de evidencia registrados.",
  "Evidence files": "Archivos de evidencia",
  "Actual outputs": "Salidas reales",
  "No actual outputs recorded.": "No hay salidas reales registradas.",
  "Operations and inspections": "Operaciones e inspecciones",
  "Create shared run": "Crear ejecución de producción compartida",
  "Record rework": "Registrar retrabajo",
  "No operations or inspections recorded.": "No hay operaciones ni inspecciones registradas.",
  "Actual components and lots": "Componentes y lotes reales",
  "Record component or lot": "Registrar componente o lote",
  "No actual components recorded.": "No hay componentes reales registrados.",
  "Job documents": "Documentos de la orden",
  "Whole job": "Orden completa",
  "Actual component": "Componente real",
  "Unserialized output": "Salida no serializada",
  "Not declared": "No declarado",
  "Declare production": "Declarar estado de producción",
  "Declare quality": "Declarar estado de calidad",
  "Amend as-built": "Modificar configuración fabricada",
  "Declaration history": "Historial de declaraciones",
  "As-built history": "Historial de configuración fabricada",
  "Snapshot": "Instantánea",
  "Choose a declaration.": "Elija una declaración.",
  "As-built snapshot": "Instantánea de configuración fabricada",
  "Actual output": "Salida real",
  "No serialized units found.": "No se encontraron unidades serializadas.",
  "Serialized output": "Salida serializada",
  "Clear": "Borrar",
  "Choose a result.": "Elija un resultado.",
  "Inspection name": "Nombre de la inspección",
  "Use shared run": "Usar ejecución compartida",
  "This job is not part of this shared run.": "Esta orden no forma parte de esta ejecución compartida.",
  "Choose another run": "Elegir otra ejecución",
  "Run identifier": "Identificador de la ejecución",
  "Serialized unit": "Unidad serializada",
  "Select the actual component or lot.": "Seleccione el componente o lote real.",
  "Serial units": "Unidades serializadas",
  "Allocate serials": "Asignar números de serie",
  "Import serial labels": "Importar identificadores de serie",
  "Void": "Invalidar",
  "Void serial": "Invalidar número de serie",
  "Reprint label": "Reimprimir etiqueta",
  "Enter positive integer serial numbers.": "Introduzca números de serie enteros positivos.",
  "Number of serials": "Cantidad de números de serie",
  "Existing serial numbers": "Números de serie existentes",
  "Serial label": "Etiqueta de serie",
  "Allow pop-ups to print this label.": "Permita ventanas emergentes para imprimir esta etiqueta.",
  "Print label": "Imprimir etiqueta",
  "Lot {lot} uses draft material revision {revision}.": "El lote {lot} usa el borrador de revisión del material {revision}.",
  "Consumed quarantined stock: {lot}.": "Se consumieron existencias en cuarentena: {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Existencias insuficientes: {lot} en {location} ({disposition}); disponible {available}, salida registrada {outgoing}.",
  "syncing": "Sincronizando",
  "Supply the selected template's values.": "Proporcione los valores de la plantilla seleccionada.",
  "Manual intake contains an unknown column.": "La entrada manual contiene una columna desconocida.",
  "A manual value is missing or too long.": "Falta un valor manual o es demasiado largo.",
  "Supply CSV text.": "Proporcione texto CSV.",
  "Supply CSV text of at most 1 MiB.": "Proporcione texto CSV de hasta 1 MiB.",
  "CSV text cannot contain null characters.": "El texto CSV no puede contener caracteres nulos.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "El CSV supera el límite de 1 MiB en UTF-8.",
  "CSV must contain valid UTF-8 text.": "El CSV debe contener texto UTF-8 válido.",
  "The CSV header is missing.": "Falta la cabecera CSV.",
  "Every header must be unique.": "Cada cabecera debe ser única.",
  "The template requires this header, even when its values are optional.": "La plantilla exige esta cabecera aunque sus valores sean opcionales.",
  "This column is not in the selected template.": "Esta columna no está en la plantilla seleccionada.",
  "CSV contains more than 500 data rows.": "El CSV contiene más de 500 filas de datos.",
  "This row must have exactly the number of fields in the header.": "Esta fila debe tener exactamente tantos campos como la cabecera.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Comillas CSV incorrectas o un campo supera los 16 000 caracteres. Corrija el origen y cree una nueva vista previa.",
  "A source reference may occur only once in a preview.": "Una referencia de origen solo puede aparecer una vez en una vista previa.",
  "Supply at least one data row.": "Proporcione al menos una fila de datos.",
  "This preview uses an older intake contract. Create a new preview.": "Esta vista previa usa reglas de importación antiguas. Cree una nueva vista previa.",
  "The selected row does not match this immutable preview.": "La fila seleccionada no coincide con esta vista previa inmutable.",
  "Correct the CSV errors and create a new preview before applying this row.": "Corrija los errores CSV y cree una nueva vista previa antes de aplicar esta fila.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "Esta fila de origen ya se aplicó con otros datos o por otra persona. No se puede sobrescribir.",
  "This row no longer meets the intake contract. Create a new preview.": "Esta fila ya no cumple las reglas de importación. Cree una nueva vista previa.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Los datos referenciados cambiaron tras la vista previa. Revise los datos actuales y cree una nueva vista previa; esta fila no se adaptó automáticamente.",
  "No exact company reference matches this value.": "Ninguna referencia exacta de esta empresa coincide con este valor.",
  "This reference is ambiguous; select an exact source reference.": "Esta referencia es ambigua; seleccione una referencia de origen exacta.",
  "This material identifier already exists; intake does not overwrite definitions.": "Este identificador de material ya existe; la importación no sobrescribe definiciones.",
  "This lot identifier already exists; intake does not overwrite lots.": "Este identificador de lote ya existe; la importación no sobrescribe lotes.",
  "Use the exact material revision unit.": "Use la unidad exacta de la revisión del material.",
  "Use the exact authored lot unit; stock is not converted.": "Use la unidad exacta definida para el lote; las existencias no se convierten.",
  "The job must produce the exact selected part.": "La orden debe producir exactamente la pieza seleccionada.",
  "This serial is already allocated or imported and cannot be reused.": "Este número de serie ya está asignado o importado y no se puede reutilizar.",
  "A serialized output is exactly one ea.": "Una salida serializada corresponde exactamente a 1 ea.",
  "A part job cannot declare a material lot output.": "Una orden de piezas no puede declarar un lote de material como salida.",
  "The operation must exist in the job's captured route.": "La operación debe existir en la ruta capturada de la orden.",
  "Select one actual output by its exact source reference.": "Seleccione una salida real mediante su referencia de origen exacta.",
  "Use at most {maximum} characters.": "Use como máximo {maximum} caracteres.",
  "A value is required.": "Se requiere un valor.",
  "Use a positive, unpadded integer.": "Use un entero positivo sin ceros iniciales.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Use una cantidad decimal positiva sin separadores de miles, con un máximo de seis decimales y doce dígitos enteros.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Use una marca de tiempo UTC real, como 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Elija Accepted o Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Elija Completed, Failed, Skipped o InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Elija Passed, Failed o Inconclusive.",
  "An imported serial requires its complete part PIN.": "Un número de serie importado requiere el PIN completo de la pieza.",
  "Choose Production or Quality.": "Elija Production o Quality.",
  "Choose a declaration value belonging to this kind.": "Elija un valor de declaración correspondiente a esta clase.",
  "This intake preview was not found for this recorder and company.": "No se encontró esta vista previa de importación para esta persona y empresa.",
  "This preview row was not found.": "No se encontró esta fila de vista previa.",
  "Choose a published intake template.": "Elija una plantilla de importación publicada.",
  "Use an actual UTC timestamp.": "Use una marca de tiempo UTC real.",
  "This material identifier already exists.": "Este identificador de material ya existe.",
  "Released or used definitions stay unchanged. Create a new revision.": "Las definiciones publicadas o utilizadas permanecen sin cambios. Cree una nueva revisión.",
  "This material revision is already released.": "Esta revisión del material ya está publicada.",
  "Use the exact material revision unit; stock is not converted.": "Use la unidad exacta de la revisión del material; las existencias no se convierten.",
  "This lot identifier already exists.": "Este identificador de lote ya existe.",
  "This lot changed. Reload its balances before recording stock.": "Este lote cambió. Recargue sus saldos antes de registrar existencias.",
  "Use the lot's exact authored unit; stock is not converted.": "Use la unidad exacta definida para el lote; las existencias no se convierten.",
  "Reverse the original movement before recording its replacement.": "Anule el movimiento original antes de registrar su sustitución.",
  "This movement already has a replacement.": "Este movimiento ya tiene una sustitución.",
  "This movement has already been corrected.": "Este movimiento ya se corrigió.",
  "Use an exact location without surrounding whitespace.": "Indique una ubicación exacta sin espacios al principio ni al final.",
  "Split and merge require the same exact material revision.": "La división y combinación requieren exactamente la misma revisión del material.",
  "Split and merge preserve disposition.": "La división y combinación conservan el estado de disposición.",
  "Split and merge quantities must match exactly.": "Las cantidades de división y combinación deben coincidir exactamente.",
  "This split or merge would create a cycle in the retained lot genealogy.": "Esta división o combinación crearía un ciclo en la genealogía conservada de los lotes.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "La cantidad debe ser positiva, con un máximo de seis decimales y doce dígitos enteros.",
  "Offline storage is unavailable. No local save was confirmed.": "El almacenamiento sin conexión no está disponible. No se confirmó ningún guardado local.",
  "Offline recording requires browser storage locking.": "El registro sin conexión requiere bloqueo del almacenamiento del navegador.",
  "Offline storage could not save the change. Keep the original work and retry.": "El almacenamiento sin conexión no pudo guardar el cambio. Conserve el trabajo original y vuelva a intentarlo.",
  "Offline session not found.": "No se encontró la sesión sin conexión.",
  "Resolve the saved change shown above before synchronizing offline work.": "Resuelva el cambio guardado que se muestra arriba antes de sincronizar el trabajo sin conexión.",
  "This offline session is not the active recorder.": "Esta sesión sin conexión no es la sesión de registro activa.",
  "Offline file storage is unavailable in this browser.": "El almacenamiento de archivos sin conexión no está disponible en este navegador.",
  "Offline storage capacity cannot be checked.": "No se puede comprobar la capacidad del almacenamiento sin conexión.",
  "Not enough browser storage for the selected offline files.": "No hay suficiente almacenamiento en el navegador para los archivos sin conexión seleccionados.",
  "Streaming downloads are unavailable.": "Las descargas en flujo no están disponibles.",
  "Choose one job and distinct offline files.": "Elija una orden y archivos sin conexión distintos.",
  "Choose distinct material lots and component units for offline use.": "Elija lotes de materiales y unidades de componentes distintos para usarlos sin conexión.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Vuelva a conectarse, resuelva el trabajo sin conexión activo y ciérrelo explícitamente antes de cambiar de persona u orden.",
  "Finish preparation or closing before resolving offline work.": "Termine la preparación o el cierre antes de resolver el trabajo sin conexión.",
  "Choose an unresolved conflicting or rejected command.": "Elija una acción en conflicto o rechazada que siga sin resolver.",
  "This offline session is not ready for new commands.": "Esta sesión sin conexión no está lista para nuevas acciones.",
  "Choose distinct evidence staged in this offline session.": "Elija evidencias distintas preparadas en esta sesión sin conexión.",
  "Only operation attempts and inspections support staged evidence.": "Solo los intentos de operación e inspecciones admiten evidencias preparadas localmente.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Suba y verifique las evidencias sin conexión referenciadas antes de sincronizar esta acción.",
  "Select at most 1000 evidence files.": "Seleccione como máximo 1000 archivos de evidencia.",
  "Finish preparation or closing before synchronizing.": "Termine la preparación o el cierre antes de sincronizar.",
  "Finish preparation before synchronizing.": "Termine la preparación antes de sincronizar.",
  "The offline command response did not confirm acceptance.": "La respuesta a la acción sin conexión no confirmó su aceptación.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Suba y adjunte las evidencias sin conexión preparadas antes de cerrar. Se conservan las evidencias locales.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Resuelva todo el trabajo pendiente, en conflicto y rechazado antes de cerrar esta sesión sin conexión.",
  "The server session was closed elsewhere. Review the retained local work.": "La sesión del servidor se cerró en otro lugar. Revise el trabajo local conservado.",
  "The server did not confirm closing this offline session.": "El servidor no confirmó el cierre de esta sesión sin conexión.",
  "This file has not been downloaded and verified for offline use.": "Este archivo no se ha descargado y verificado para usarlo sin conexión.",
  "This offline session is not ready for new evidence.": "Esta sesión sin conexión no está lista para nuevas evidencias.",
  "Choose a nonempty evidence file and filename.": "Elija un archivo de evidencia no vacío e indique su nombre.",
  "This evidence has not been staged for offline use.": "Esta evidencia no se ha preparado para usarla sin conexión.",
  "Finish closing before updating evidence.": "Termine el cierre antes de actualizar las evidencias.",
  "Offline evidence changed. Read its current state before continuing.": "Las evidencias sin conexión cambiaron. Revise su estado actual antes de continuar.",
  "Resume the original evidence upload.": "Reanude la carga original de la evidencia.",
  "The verified server file does not match the staged evidence.": "El archivo verificado del servidor no coincide con la evidencia preparada.",
  "This offline session belongs to another recorder.": "Esta sesión sin conexión pertenece a otra persona.",
  "This offline session is closed. Its pending work cannot be submitted here.": "Esta sesión sin conexión está cerrada. Su trabajo pendiente no se puede enviar aquí.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "Este identificador de acción ya está vinculado a otro trabajo. Conserve la acción original y registre las correcciones por separado.",
  "Use a serial reserved for this job before the session was prepared.": "Use un número de serie reservado para esta orden antes de preparar la sesión.",
  "This component unit changed. Keep the recorded work and review the conflict.": "Esta unidad de componente cambió. Conserve el trabajo registrado y revise el conflicto.",
  "This component revision changed. Keep the recorded work and review the conflict.": "Esta revisión del componente cambió. Conserve el trabajo registrado y revise el conflicto.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "Este lote de material cambió. Conserve el trabajo registrado y revise el conflicto de existencias antes de enviar una corrección.",
  "This material revision changed. Keep the recorded work and review the conflict.": "Esta revisión del material cambió. Conserve el trabajo registrado y revise el conflicto.",
  "The command payload does not match its record type. Keep the original pending work for review.": "Los datos de la acción no coinciden con su tipo de registro. Conserve el trabajo pendiente original para revisarlo.",
  "Not started": "No iniciado",
  "In progress": "En curso",
  "Captured part revision was a draft.": "La revisión de pieza capturada era un borrador.",
  "Captured configuration was a draft.": "La configuración capturada era un borrador.",
  "A captured component revision was a draft.": "Una revisión de componente capturada era un borrador.",
  "Captured material revision was a draft.": "La revisión del material capturada era un borrador.",
  "Captured route revision was a draft.": "La revisión de ruta capturada era un borrador.",
  "A captured document revision was a draft.": "Una revisión de documento capturada era un borrador.",
  "No route was captured.": "No se capturó ninguna ruta.",
  "An operation has no completed attempt.": "Una operación no tiene ningún intento completado.",
  "An expected inspection was not recorded.": "No se registró una inspección prevista.",
  "The history includes failed operations.": "El historial incluye operaciones fallidas.",
  "The history includes skipped operations.": "El historial incluye operaciones omitidas.",
  "The history includes failed inspections.": "El historial incluye inspecciones no superadas.",
  "The history includes inconclusive inspections.": "El historial incluye inspecciones no concluyentes.",
  "No inspection evidence was recorded.": "No se registraron evidencias de inspección.",
  "Planned components have no recorded actuals.": "Los componentes previstos no tienen uso real registrado.",
  "A planned component quantity differs from the recorded actuals.": "La cantidad prevista de un componente difiere de la cantidad real registrada.",
  "Quality has not been declared.": "No se ha declarado el estado de calidad.",
  "Production has not been declared.": "No se ha declarado el estado de producción.",
  "Some actual components are recorded for the whole job, not an individual output.": "Algunos componentes reales se registraron para la orden completa, no para una salida individual.",
  "Some completed operations have no file evidence.": "Algunas operaciones completadas no tienen archivos de evidencia.",
  "An operation was recorded out of order.": "Se registró una operación fuera de secuencia.",
  "The serial label is void.": "El identificador de serie está invalidado.",
  "Additional evidence warning recorded.": "Se registró un aviso adicional sobre evidencias.",
  "Document": "Documento",
  "Applies to output": "Se aplica a la salida",
  "Earlier lot": "Lote anterior",
  "From lot": "Del lote",
  "Captured component evidence": "Evidencias de componente capturadas",
  "Actual genealogy": "Genealogía real",
  "Related operation": "Operación relacionada",
  "Shared runs": "Ejecuciones de producción compartidas",
  "Add job to shared run": "Añadir orden a ejecución compartida",
  "Actual component type": "Tipo de componente real",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "Una acción de registro aceptada debe confirmar que se adjuntó esta evidencia.",
  "Choose a downloaded material lot or component serial.": "Elija un lote de material o componente serializado descargado.",
  "Choose a supported evidence update.": "Elija una actualización de evidencia compatible.",
  "Choose a supported offline command and an object payload.": "Elija una acción sin conexión compatible y datos en forma de objeto.",
  "Choose the output receiving this component.": "Elija la salida que recibe este componente.",
  "Evidence file references must be a list of server file IDs.": "Las referencias de archivos de evidencia deben ser una lista de identificadores de archivos del servidor.",
  "Evidence upload failed.": "Error al subir la evidencia.",
  "Offline payloads must contain only JSON values.": "Los datos de las acciones sin conexión solo deben contener valores JSON.",
  "Online registry": "Registro en línea",
  "Provide a corrected command payload object.": "Proporcione los datos corregidos de la acción en forma de objeto.",
  "Provide the evidence upload error.": "Indique el error de carga de la evidencia.",
  "Reconnect to verify recorder access before synchronizing.": "Vuelva a conectarse para verificar el acceso de quien registra antes de sincronizar.",
  "The offline bundle is missing selected material lots or component units.": "Faltan lotes de materiales o unidades de componentes seleccionados en el paquete sin conexión.",
  "The offline file SHA-256 does not match its manifest.": "El SHA-256 del archivo sin conexión no coincide con su manifiesto.",
  "The offline file URL does not match its session.": "La URL del archivo sin conexión no coincide con su sesión.",
  "The offline file length does not match its manifest.": "El tamaño del archivo sin conexión no coincide con su manifiesto.",
  "The offline file manifest is invalid.": "El manifiesto del archivo sin conexión no es válido.",
  "The offline manifest does not match the selected files.": "El manifiesto sin conexión no coincide con los archivos seleccionados.",
  "The offline session does not belong to this recorder and job.": "La sesión sin conexión no pertenece a esta persona y orden.",
  "The prepared offline bundle does not match this recorder and job.": "El paquete sin conexión preparado no corresponde a esta persona y orden.",
  "The retained correction chain is incomplete.": "La cadena de correcciones conservada está incompleta.",
  "The retained correction chain is invalid.": "La cadena de correcciones conservada no es válida.",
  "The selected job changed. Open its download choices again.": "La orden seleccionada cambió. Vuelva a abrir sus opciones de descarga.",
  "The selected offline file could not be downloaded.": "No se pudo descargar el archivo sin conexión seleccionado.",
  "The staged evidence failed SHA-256 verification.": "La evidencia preparada localmente no superó la verificación SHA-256.",
  "The stored offline evidence failed SHA-256 verification.": "La evidencia sin conexión guardada no superó la verificación SHA-256.",
  "The stored offline file failed SHA-256 verification.": "El archivo sin conexión guardado no superó la verificación SHA-256.",
  "This offline session is closed.": "Esta sesión sin conexión está cerrada.",
  "This offline session is closed. Pending work is retained.": "Esta sesión sin conexión está cerrada. Se conserva el trabajo pendiente.",
  "Agent": "Agente",
  "Agents": "Agentes",
  "Member": "Miembro",
  "Agent name": "Nombre del agente",
  "Agent reference": "Referencia del agente",
  "Connected applications": "Aplicaciones conectadas",
  "Connection address": "Dirección de conexión",
  "MCP endpoint": "Punto de conexión MCP",
  "New agent": "Nuevo agente",
  "Create agent": "Crear agente",
  "Manage": "Gestionar",
  "Review transfer": "Revisar transferencia",
  "Management transfer awaiting your response": "La transferencia de gestión espera su respuesta",
  "Management transfer pending": "Transferencia de gestión pendiente",
  "No connected applications.": "No hay aplicaciones conectadas.",
  "No agents yet.": "Aún no hay agentes.",
  "Last used {date}": "Último uso: {date}",
  "Disconnect": "Desconectar",
  "Disconnect {name}?": "¿Desconectar {name}?",
  "This application will lose access through this connection.": "Esta aplicación perderá el acceso mediante esta conexión.",
  "Manage {name}?": "¿Gestionar {name}?",
  "Accept management": "Aceptar gestión",
  "Decline transfer": "Rechazar transferencia",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Aceptar la gestión revoca las credenciales existentes. Cree nuevas credenciales antes de volver a ejecutar el agente.",
  "Disabled": "Desactivado",
  "Enable agent": "Activar agente",
  "Disable agent": "Desactivar agente",
  "Enable {name}?": "¿Activar {name}?",
  "Disable {name}?": "¿Desactivar {name}?",
  "Rename": "Cambiar nombre",
  "Rename agent": "Cambiar nombre del agente",
  "Transfer management": "Transferir gestión",
  "Cancel transfer": "Cancelar transferencia",
  "Request transfer": "Solicitar transferencia",
  "New manager’s Google account email": "Correo de Google del nuevo responsable",
  "Share agent reference": "Compartir referencia del agente",
  "Company access": "Acceso a empresas",
  "No company access. A company owner can add this agent in Members.": "Sin acceso a empresas. Un propietario puede añadir el agente en Miembros.",
  "Credentials": "Credenciales",
  "New credential": "Nueva credencial",
  "Create credential": "Crear credencial",
  "Credential name": "Nombre de la credencial",
  "No credentials yet.": "Aún no hay credenciales.",
  "Rotate secret": "Renovar secreto",
  "Rotate {name}?": "¿Renovar el secreto de {name}?",
  "Revoke {name}?": "¿Revocar {name}?",
  "Create new credentials after enabling this agent.": "Cree nuevas credenciales después de activar este agente.",
  "This revokes its credentials and stops access in every company.": "Esto revoca sus credenciales y detiene el acceso a todas las empresas.",
  "Existing access tokens issued with this credential will stop working.": "Los tokens de acceso emitidos con esta credencial dejarán de funcionar.",
  "Connection credentials": "Credenciales de conexión",
  "Client ID": "ID del cliente",
  "Client secret": "Secreto del cliente",
  "The secret is shown only once. Save it in your agent’s credential storage.": "El secreto se muestra una sola vez. Guárdelo en el almacén de credenciales del agente.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "La credencial se creó, pero el secreto no puede volver a mostrarse. Renuévelo.",
  "Copy {value}": "Copiar {value}",
  "Copy was unavailable. Select the value and copy it manually.": "No se pudo copiar. Seleccione el valor y cópielo manualmente.",
  "Add agent": "Añadir agente",
  "Choose a valid agent reference.": "Indique una referencia de agente válida.",
  "Managed by {name}": "Gestionado por {name}",
  "Connect application": "Conectar aplicación",
  "Allow connection": "Permitir conexión",
  "Redirect address": "Dirección de redirección",
  "This application can use your current company roles. Access follows changes to your memberships.": "Esta aplicación puede usar sus roles actuales en las empresas. El acceso cambia con sus membresías.",
  "Agent created": "Agente creado",
  "Agent updated": "Agente actualizado",
  "Agent disabled": "Agente desactivado",
  "Credential created": "Credencial creada",
  "Credential rotated": "Credencial renovada",
  "Credential revoked": "Credencial revocada",
  "Transfer requested": "Transferencia solicitada",
  "Transfer cancelled": "Transferencia cancelada",
  "Transfer accepted": "Transferencia aceptada",
  "Active agent not found.": "No se encontró un agente activo.",
  "Agent not found.": "No se encontró el agente.",
  "Managed agent not found.": "No se encontró el agente gestionado.",
  "Credential not found.": "No se encontró la credencial.",
  "Connection not found.": "No se encontró la conexión.",
  "Transfer not found.": "No se encontró la transferencia.",
  "This transfer has expired.": "Esta transferencia ha caducado.",
  "Choose another manager.": "Elija otro responsable.",
  "The new manager must sign in to the registry first.": "El nuevo responsable debe iniciar sesión en el registro primero.",
  "A human account manages agent credentials.": "Las credenciales del agente se gestionan desde una cuenta personal.",
  "Enable the agent before creating credentials.": "Active el agente antes de crear credenciales.",
  "Create a new credential after revocation.": "Cree una nueva credencial después de la revocación.",
  "This agent is already a member.": "Este agente ya es miembro.",
  "Another owner must accept membership before disabling the last owner.": "Otro propietario debe aceptar la membresía antes de desactivar al último.",
  "Application not found.": "No se encontró la aplicación.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Piezas comunes",
  "Common": "Común",
  "Add part to {value0}": "Añadir pieza a {value0}",
  "Assembly actions": "Acciones del ensamblaje",
  "Create symmetry": "Crear simetría",
  "Variant created.": "Variante creada.",
  "Symmetry family updated.": "Familia de simetría actualizada.",
  "Document categories": "Categorías de documentos",
  "Document category": "Categoría de documento",
  "Add category": "Añadir categoría",
  "Edit category": "Editar categoría",
  "Edit category {name}": "Editar categoría {name}",
  "Category added.": "Categoría añadida.",
  "Category saved.": "Categoría guardada.",
  "Category name": "Nombre de la categoría",
  "Category code": "Código de categoría",
  "App default": "Predeterminada",
  "Archived": "Archivada",
  "Show archived categories": "Mostrar categorías archivadas",
  "No categories available.": "No hay categorías disponibles.",
  "Reload": "Recargar",
  "Only company owners and editors can manage document categories.": "Solo los propietarios y editores de la empresa pueden gestionar las categorías de documentos.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Varias categorías existentes comparten estos códigos: {codes}. Sus registros siguen separados.",
  "Upload document": "Subir documento",
  "Apply to selected": "Aplicar a la selección",
  "Back to files": "Volver a los archivos",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "El almacenamiento del navegador no está disponible. Mantenga esta ventana abierta para conservar sus cambios.",
  "Category for {name}": "Categoría de {name}",
  "Check the saved upload change before continuing.": "Revise el cambio guardado de la subida antes de continuar.",
  "Choose a matching document": "Elegir un documento coincidente",
  "Choose which document should receive this revision.": "Elija el documento al que se añadirá esta revisión.",
  "Create a separate document": "Crear un documento independiente",
  "Detected from": "Detectado a partir de",
  "Drag and drop files here": "Arrastre y suelte los archivos aquí",
  "Edit selected files": "Editar archivos seleccionados",
  "Edit {count} selected files": "Editar {count} archivos seleccionados",
  "File details and applicability": "Detalles y aplicabilidad del archivo",
  "File preview": "Vista previa del archivo",
  "File size": "Tamaño del archivo",
  "Filename": "Nombre del archivo",
  "Keep current": "Mantener valores actuales",
  "Matching document for {name}": "Documento coincidente de {name}",
  "New document": "Documento nuevo",
  "New revision of {identifier}": "Nueva revisión de {identifier}",
  "Next file": "Archivo siguiente",
  "Not specified": "Sin especificar",
  "Preview unavailable for this file format.": "La vista previa no está disponible para este formato de archivo.",
  "Preview {name}": "Vista previa de {name}",
  "Previous file": "Archivo anterior",
  "Reading file details…": "Leyendo los detalles de los archivos…",
  "Recover saved upload": "Recuperar la subida guardada",
  "Select a file to preview.": "Seleccione un archivo para ver su vista previa.",
  "Select all files": "Seleccionar todos los archivos",
  "Select files": "Seleccionar archivos",
  "Select files to upload.": "Seleccione los archivos que desea subir.",
  "Select the original file to preview or resume.": "Seleccione el archivo original para previsualizarlo o reanudar la subida.",
  "Select the original file to resume.": "Seleccione el archivo original para reanudar la subida.",
  "Select {name}": "Seleccionar {name}",
  "Title for {name}": "Título de {name}",
  "Title pattern": "Plantilla de título",
  "Uploading {name}": "Subiendo {name}",
  "Use {name} for the current title and {n} for a sequence number.": "Use {name} para el título actual y {n} para un número de secuencia.",
  "{count} files": "{count} archivos",
  "{count} selected": "{count} seleccionados",
  "{done} of {total} uploaded": "{done} de {total} subidos",
  "Add files": "Añadir archivos",
  "Retry unfinished uploads": "Reintentar subidas pendientes",
  "Drawing": "Plano",
  "Assembly drawing": "Plano de conjunto",
  "Production drawing": "Plano de fabricación",
  "Bill of materials": "Lista de materiales",
  "Work instruction": "Instrucción de trabajo",
  "Schematic": "Esquema",
  "Wiring diagram": "Diagrama de cableado",
  "Layout": "Disposición",
  "3D model": "Modelo 3D",
  "Test procedure": "Procedimiento de ensayo",
  "Test report": "Informe de ensayo",
  "Inspection plan": "Plan de inspección",
  "Inspection report": "Informe de inspección",
  "Certificate": "Certificado",
  "Material datasheet": "Ficha técnica del material",
  "Calculation": "Cálculo",
  "Requirements": "Requisitos",
  "Design report": "Informe de diseño",
  "Assembly instruction": "Instrucción de montaje",
  "Manufacturing process": "Proceso de fabricación",
  "Quality plan": "Plan de calidad",
  "Change notice": "Aviso de cambio",
  "Manual": "Manual",
  "Upload": "Subir",
  "Ready": "Listo",
  "Needs attention": "Requiere atención",
  "Retained": "Conservada",
  "manual": "Edición manual",
  "filename": "Nombre del archivo",
  "embedded metadata": "Metadatos integrados",
  "filename fallback": "Nombre del archivo; categoría general",
  "Embedded metadata": "Metadatos integrados",
  "Embedded title": "Título integrado",
  "File selection key": "Clave de selección del archivo",
  "Media type": "Tipo de medio",
  "Document category added": "Categoría de documentos añadida",
  "Document category archived": "Categoría de documentos archivada",
  "Document category updated": "Categoría de documentos actualizada",
  "Document upload batch created": "Lote de subida de documentos creado",
  "Document draft retained": "Borrador del documento conservado",
  "Document upload saved": "Documento subido guardado",
  "Add a Company or Project category.": "Añada una categoría de empresa o de proyecto.",
  "Choose a category available in this document context.": "Elija una categoría disponible en el contexto de este documento.",
  "Choose a project only for a Project category.": "Seleccione un proyecto solo para una categoría de proyecto.",
  "Choose the project that owns this document context.": "Elija el proyecto al que pertenece el contexto de este documento.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "Este código de categoría ya existe en este ámbito o en uno heredado. Elija otro código.",
  "This category is archived. Choose an available category.": "Esta categoría está archivada. Elija una categoría disponible.",
  "This editable category was not found in this company.": "No se encontró esta categoría editable en la empresa.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Use un código de categoría con letras mayúsculas y números que empiece por una letra.",
  "A saved document file cannot be removed from its upload batch.": "No se puede quitar un archivo de documento guardado de su lote de subida.",
  "A selected file key is already in this batch.": "La clave de un archivo seleccionado ya está en este lote.",
  "Choose a document category.": "Elija una categoría de documento.",
  "Choose a row in this upload batch.": "Elija una fila de este lote de subida.",
  "Choose an available document category.": "Elija una categoría de documento disponible.",
  "Choose between 1 and 1000 files.": "Elija entre 1 y 1000 archivos.",
  "Choose distinct upload rows to edit.": "Elija filas de subida distintas para editarlas.",
  "Choose either an existing document or a new document.": "Elija un documento existente o uno nuevo.",
  "Resume this batch with the recorder who started it.": "Reanude este lote con la cuenta que lo inició.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Varios documentos coinciden con este archivo. Elija el documento deseado o cree uno independiente.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "El documento seleccionado ya no coincide con este propietario, categoría y título. Revise la fila de nuevo.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "Este documento tiene una subida pendiente. Complétela o cancélela antes de reintentar esta fila.",
  "This upload batch was cancelled.": "Este lote de subida se canceló.",
  "This upload row is already saved or cancelled.": "Esta fila de subida ya se guardó o canceló.",
  "Upload and verify this file before saving the document.": "Suba y verifique este archivo antes de guardar el documento.",
  "Select the original file for this upload row.": "Seleccione el archivo original para esta fila de subida.",
  "This row already has a different upload. Cancel that upload before replacing it.": "Esta fila ya tiene otra subida. Cancélela antes de reemplazarla.",
  "Preview will be available after upload.": "La vista previa estará disponible después de la carga.",
  "existing document": "Documento existente",
  "file extension": "Extensión del archivo",
  "More": "Más",
  "Edit quantity for {value0}": "Editar cantidad para {value0}",
  "This structure cannot contain itself.": "Esta estructura no puede contenerse a sí misma."
}
